/**
 * Ajuda dos campos de comissoes.
 *
 * Juntada em `../ajudaDosCampos.ts`, que explica a chave e o texto. Ver
 * docs/FRONTEND.md, secao 6.
 */
// Ajuda da carteira de apolices e de fiancas (P-APO-1): o painel de filtros, a
// configuracao da apolice, as parcelas e os arquivos do historico. O detalhe
// (/apolices/:id) herda da lista.
const ajudaDaCarteira: Record<string, string> = {
  'Numero da apolice':
    'Numero exato da apolice: o da seguradora ou do banco, ou o numero interno. Parte do numero nao acha; para isso use a busca.',
  'Status da apolice':
    'Emitida e a apolice vigente. Aguardando Emissao sao as operacoes em emissao, sem apolice ainda. Rejeitada nao e registrada no SeguraCore.',
  'Data inicial':
    'Primeiro dia da emissao procurada, no fuso de Brasilia. Qual data vale para o filtro (emissao ou vigencia) esta a confirmar.',
  'Data final': 'Ultimo dia da emissao procurada. Exige a data inicial.',
  'Tipo de cosseguro':
    'Cedido ou aceito. As opcoes estao a confirmar, e o cosseguro chega com o financeiro da cotacao.',
  'Nome do tomador':
    'Parte do nome do tomador como a apolice o guardou na emissao, e nao como o cadastro diz hoje.',
  'Documento do tomador':
    'CNPJ ou CPF do tomador, inteiro ou pelo comeco. A pontuacao e ignorada.',
  'Nome do segurado': 'Parte do nome do segurado como a apolice o guardou na emissao.',
  'Documento do segurado': 'CNPJ ou CPF do segurado, inteiro ou pelo comeco.',
  'Nome do corretor': 'Parte do nome da corretora como a apolice a guardou na emissao.',
  Lista: 'Troca entre a lista de propostas (cotacoes) e a lista de apolices.',
  'Numero da apolice gerado por':
    'Quem da o numero da apolice e decisao do dono ainda aberta. Informado: digitado na emissao. SeguraCore: 12 digitos com o prefixo e o numero interno.',
  'Prefixo do numero':
    'De zero a seis digitos, so no numero gerado pelo SeguraCore. O numero que nao cabe em 12 digitos e recusado, e nao cortado.',
  Boleto:
    'Desligado: nao ha boleto, porque nao ha integracao bancaria. Anexado: o boleto emitido fora do SeguraCore e anexado a parcela por quem tem a alcada.',
  'Numero da parcela': 'Ordem da parcela, de 1 a 999, sem repetir na apolice.',
  'Valor da parcela (R$)':
    'Valor informado da parcela. O SeguraCore nao divide o premio em parcelas: a regra do parcelamento esta pendente.',
  'Juros (R$)':
    'Juros informados da parcela. Vazio e sem juros. Nenhum juro e calculado.',
  Vencimento:
    'Data de vencimento informada. Os vencimentos nao sao calculados: a regra esta pendente.',
  'Situacao da parcela':
    'Informada por quem tem a alcada. Se o SeguraCore controla o pagamento e decisao aberta, por isso nada muda a situacao sozinho.',
  'Pago em': 'Data do pagamento, so na parcela paga.',
  'Boleto anexado':
    'Documento da apolice com o arquivo do boleto. O mesmo boleto em todas as parcelas e o boleto unico.',
  'Numero do boleto':
    'Numero ou linha de identificacao do boleto, como veio de quem o emitiu.',
  'Documento da apolice':
    'Documento da propria apolice com arquivo enviado, que passa a aparecer no movimento.',
  'Tipo do arquivo':
    'O que o arquivo e no movimento: a apolice, o endosso, o boleto, o laudo ou outro.',
  // Assistente de endosso (P-END-1), aberto sob a apolice.
  'Selecione o tipo de endosso':
    'Subtipos ativos dos tipos de endosso habilitados para a empresa. Iniciar confere no servidor se a apolice aceita o endosso.',
  'Motivo do endosso':
    'No assistente, a lista de motivos do subtipo, que cria os documentos exigidos. Na solicitacao simplificada, o texto do motivo.',
  Observacao: 'Texto livre do endosso, que acompanha o motivo escolhido.',
  'Nomear documento:':
    'Nome de um documento a mais do endosso, que recebe o arquivo em seguida.',
  'Modo de edicao do objeto':
    'Editar so os dados com TAG ou todo o texto do objeto. O objeto alterado so muda a apolice quando o calculo do endosso entrar.',
  'Valor IS modalidade principal':
    'IS nova pedida. Fica guardada no rascunho: o premio do endosso ainda nao tem regra homologada.',
  'Valor IS modalidade complementar':
    'IS nova da modalidade complementar, guardada no rascunho sem calculo.',
  'Condicao particular':
    'Texto da condicao particular incluida ou alterada pelo endosso, guardado no rascunho.',
  'Observacao da desistencia': 'Opcional. Fica no endosso cancelado e na trilha.',
  // Endosso com efeito financeiro (P-END-2).
  'Data de cancelamento':
    'Data em que a garantia deixa de valer, dentro da vigencia da apolice. Ate quando pode ser retroativa esta a confirmar.',
  'Valor solicitado':
    'Valor que quem pede o endosso informa. Nao vira premio do endosso: o premio e a restituicao sao regra pendente.',
  'Valor sugerido':
    'Valor que a revisao pede. A revisao so fica registrada: quem revisa e com que alcada esta a confirmar.',
  'Justificativa para solicitacao de revisao':
    'Obrigatoria. Fica no endosso, na trilha e na linha do tempo da cotacao de endosso.',
};

export const ajuda: Record<string, Record<string, string>> = {
  '/apolices': ajudaDaCarteira,
  '/fiancas': ajudaDaCarteira,
  '/comissoes': {
    'Base de calculo (R$)':
      'Valor sobre o qual o percentual incide no lancamento manual. A comissao e calculada pelo servidor: base x percentual.',
    'Percentual (%)': 'Percentual da comissao, entre 0 e 100.',
    'Motivo do lancamento':
      'Obrigatorio. Explica por que a comissao nao nasceu de uma emissao, e vai para a exportacao.',
  },
};
